/**
 * Quick Add to Cart Functionality
 * This script handles the functionality for the quick add buttons on product grid items
 */

// Global add to cart function that can be called directly via onclick attributes
window.addToCartDirect = function(variantId, element) {
  // Save original text and update status
  const originalText = element.textContent || 'Add to cart';
  element.textContent = 'Adding...';
  element.classList.add('is-adding');
  
  // Add to cart via AJAX
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      items: [
        {
          id: variantId,
          quantity: 1
        }
      ]
    })
  })
  .then(response => response.json())
  .then(data => {
    // Success - update button
    element.textContent = 'Added!';
    
    // Reset button after delay
    setTimeout(() => {
      element.textContent = originalText;
      element.classList.remove('is-adding');
    }, 2000);
    
    // Dispatch event that the theme is listening for
    document.dispatchEvent(
      new CustomEvent('ajaxProduct:added', {
        detail: {
          product: data
        }
      })
    );
    
    // Update cart drawer/icon if available
    if (typeof window.refreshCart === 'function') {
      window.refreshCart();
    }
  })
  .catch(error => {
    // Error
    console.error('Error adding product to cart:', error);
    element.textContent = 'Error';
    
    // Reset button after delay
    setTimeout(() => {
      element.textContent = originalText;
      element.classList.remove('is-adding');
    }, 2000);
  });
  
  return false; // Prevent default action
};

;(function () {
  // Quick Add functionality
  class QuickAdd {
    constructor() {
      this.initEvents()
      
      // Set up a MutationObserver to catch dynamically added buttons
      this.setupMutationObserver()
    }
    
    setupMutationObserver() {
      // Create a MutationObserver to watch for newly added quick-add buttons
      const observer = new MutationObserver((mutations) => {
        let shouldInit = false
        
        mutations.forEach(mutation => {
          if (mutation.type === 'childList' && mutation.addedNodes.length) {
            // Check if any of the added nodes contain quick-add buttons
            mutation.addedNodes.forEach(node => {
              if (node.nodeType === 1) { // ELEMENT_NODE
                if (node.classList && node.classList.contains('js-quick-add-btn')) {
                  shouldInit = true
                } else if (node.querySelectorAll) {
                  const buttons = node.querySelectorAll('.js-quick-add-btn')
                  if (buttons.length) {
                    shouldInit = true
                  }
                }
              }
            })
          }
        })
        
        // If new buttons were added, initialize them
        if (shouldInit) {
          this.initEvents()
        }
      })
      
      // Observe the entire document for changes
      observer.observe(document.body, {
        childList: true,
        subtree: true
      })
    }

    initEvents() {
      // Get all quick add buttons on the page
      const quickAddButtons = document.querySelectorAll(".js-quick-add-btn")
      
      quickAddButtons.forEach((button) => {
        // Skip if button already has onclick attribute
        if (button.hasAttribute("onclick")) {
          return
        }
        
        // Add direct onclick handler to each button
        const variantId = button.getAttribute("data-id")
        const productId = button.getAttribute("data-product-id")

        // Remove any existing click listeners to avoid duplicates
        const newButton = button.cloneNode(true)
        button.parentNode.replaceChild(newButton, button)

        // Add the onclick attribute directly using the global function
        newButton.setAttribute(
          "onclick",
          `return window.addToCartDirect(${variantId}, this);`
        )
      })

      // Re-init on section load/change
      document.addEventListener("shopify:section:load", this.init.bind(this))
      document.addEventListener("shopify:section:select", this.init.bind(this))
    }

    init() {
      this.quickAddButtons = document.querySelectorAll(".js-quick-add-btn")
      this.initEvents()
    }

    handleAddToCart(event) {
      event.preventDefault()
      const button = event.currentTarget
      const variantId = button.getAttribute("data-id")

      // Change button text to indicate loading
      const originalText = button.textContent
      button.textContent = "Adding..."
      button.classList.add("is-adding")

      // Add to cart via AJAX
      this.addToCart(variantId, 1)
        .then((response) => {
          // Success
          button.textContent = "Added!"

          // Reset button after delay
          setTimeout(() => {
            button.textContent = originalText
            button.classList.remove("is-adding")
          }, 2000)

          // Dispatch the event that the theme is listening for
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added", {
              detail: {
                product: response
              }
            })
          )

          // Update cart drawer/icon if available
          if (typeof window.refreshCart === "function") {
            window.refreshCart()
          }
        })
        .catch((error) => {
          // Error
          console.error("Error adding product to cart:", error)
          button.textContent = "Error"

          // Reset button after delay
          setTimeout(() => {
            button.textContent = originalText
            button.classList.remove("is-adding")
          }, 2000)
        })
    }

    addToCart(id, quantity) {
      return fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          items: [
            {
              id: id,
              quantity: quantity
            }
          ]
        })
      }).then((response) => response.json())
    }

    openCartDrawer() {
      // Refresh the cart to make sure the content is up to date
      this.refreshCart()
        .then(() => {
          // For this specific theme, we need to access the CartDrawer instance
          if (window.theme && window.theme.CartDrawer) {
            // First refresh the cart content if there's an update method
            if (typeof window.theme.CartDrawer.buildCart === "function") {
              window.theme.CartDrawer.buildCart()
            }

            // Then open the drawer
            window.theme.CartDrawer.open()
            return
          }

          // If there's a drawer instance in the theme
          if (window.theme && window.theme.Drawers) {
            const cartDrawer = new window.theme.Drawers("CartDrawer", "cart")
            cartDrawer.open()
            return
          }

          // Generic implementation as fallback
          const drawerCart = document.querySelector("#CartDrawer")
          if (drawerCart) {
            document.documentElement.classList.add("js-drawer-open")
            document.documentElement.classList.add("js-drawer-open-right")
            drawerCart.classList.add("drawer--is-open")
          }
        })
        .catch((err) => {
          console.error("Error refreshing cart:", err)
        })
    }

    refreshCart() {
      return fetch("/cart.js")
        .then((response) => response.json())
        .then((cart) => {
          // Trigger cart update events that the theme might listen to
          document.dispatchEvent(
            new CustomEvent("cart:updated", {
              detail: { cart: cart }
            })
          )

          document.dispatchEvent(
            new CustomEvent("cart:build", {
              detail: { cart: cart }
            })
          )

          return cart
        })
    }
  }

  // Initialize quick add when DOM is loaded
  document.addEventListener("DOMContentLoaded", () => {
    new QuickAdd()
  })
  
  // Add event listeners for Shopify section events
  document.addEventListener("shopify:section:load", () => {
    new QuickAdd().initEvents()
  })
  
  document.addEventListener("shopify:block:select", () => {
    new QuickAdd().initEvents()
  })
  
  // Listen for recommended products loaded event
  document.addEventListener("recommendations:loaded", () => {
    new QuickAdd().initEvents()
  })
})()
